import React from 'react';
import PropTypes from 'prop-types';

const variantClasses = {
  default: 'bg-white border-gray-200',
  interactive:
    'bg-white border-gray-200 hover:border-blue-300 hover:shadow-md transition-all cursor-pointer',
  selected: 'bg-blue-50 border-blue-500',
};

const paddingClasses = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

const Card = ({
  children,
  variant = 'default',
  padding = 'md',
  className = '',
  ...props
}) => {
  return (
    <div
      className={`rounded-lg border shadow-sm ${variantClasses[variant]} ${paddingClasses[padding]} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['default', 'interactive', 'selected']),
  padding: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),
  className: PropTypes.string,
};

export const CardHeader = ({ children, className = '' }) => (
  <div className={`mb-4 ${className}`}>{children}</div>
);

CardHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export const CardBody = ({ children, className = '' }) => (
  <div className={className}>{children}</div>
);

CardBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export const CardFooter = ({ children, className = '' }) => (
  <div className={`mt-4 ${className}`}>{children}</div>
);

CardFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Card;


